import { Global, css } from '@emotion/react';
import listStyles from '../styles/ui/lists';
import { theme } from './default-theme';

const globalStyles = () => css`
  body {
    color: ${theme.palette.darkGrey};
    line-height: 1.43;

    &.overflow-scroll-bar {
      overflow-y: scroll !important;
      padding-right: 0 !important;
    }

    &.overflow-hidden {
      overflow: hidden;
    }

    &.ReactModal__Body--open {
      overflow: hidden;
    }
  }
  ${listStyles(theme)}
  p {
    font-size: inherit;
  }
  button {
    font-family: ${theme.fontFamily};
  }
  h1 {
    ${theme.typography.h1}
  }
  h2 {
    ${theme.typography.h2}
  }
  h3 {
    ${theme.typography.h3}
  }
  h4 {
    ${theme.typography.h4}
  }
  h5 {
    ${theme.typography.h5}
  }
  h6 {
    ${theme.typography.h6}
  }

  a {
    color: ${theme.palette.vividBlue};
  }

  iframe#launcher {
    ${theme.props.mobileNavDown} {
      bottom: 80px !important;
      z-index: 2 !important;
    }
  }
`;

// Export both the css function and a Global component
export const GlobalStyles = () => <Global styles={globalStyles()} />;

export default globalStyles;
